import { ReactElement, createContext, useContext } from 'react';

type SavedViewsMenuProps = {
  selectedCategories: Set<string>;
  selectedLayers: Set<string>;
  selectedOrderStatuses: Set<string>;
  setCategories: (categories: string[]) => void;
  setSelectedLayers: (layers: string[]) => void;
  setOrderStatuses: (statuses: string[]) => void;
  projectId: string;
};

type CommentsPopoverProviderPros = {
  attributes: SavedViewsMenuProps;
  children: ReactElement;
};

// Create a context for the CommentsPopover attributes
const CommentsPopoverContext = createContext<SavedViewsMenuProps | null>(null);

// Create a custom hook to access the context
export function useCommentsPopoverAttributes(): SavedViewsMenuProps {
  const CommentPopoverContextValue = useContext(CommentsPopoverContext);
  if (CommentPopoverContextValue === null) {
    throw new Error('useViewer must be used within a ForgeViewerContext');
  } else {
    return CommentPopoverContextValue;
  }
}

// Create a provider component to wrap your component
export function CommentsPopoverProvider({
  children,
  attributes,
}: CommentsPopoverProviderPros) {
  return (
    <CommentsPopoverContext.Provider value={attributes}>
      {children}
    </CommentsPopoverContext.Provider>
  );
}
